// similar enum is used in rp, starts from 200 for easier identification
export enum ApplicationSourceSection {
    PropertyBoxLeadModal = 200,
    PropertyBoxOneClickLead = 201,
    PropertyModalOneClickLead = 202,
    PropertyModalLeadModal = 203,
    PropertyModalOneClickLeadMobileModal = 204,
    PropertyModalLeadModalMobile = 205,
    AfterRecommendationLikeQuestionOneClickLead = 206,
    AfterFavouriteLikeQuestionOneClickLead = 207,
    AfterRecommendationLikeQuestionModal = 208,
    AfterFavouriteLikeQuestionModal = 209,
    PropertyPartnerApiAltar = 210,
    OfferPartnerApiAltar = 211,
    RecommendedPropertiesCarouselAskOffer = 213,
    InvestmentTileAskOffer = 214,
    InvestmentTileLeadModal = 215,
    InvestmentDetailAskOffer = 216,
    InvestmentDetailLeadModal = 217
    // ATTENTION: remember to inform backend to add new value to database validation
}
// similar enum is used in rp, starts from 200 for easier identification
export enum ApplicationSourceSection {
    PropertyBoxLeadModal = 200,
    PropertyBoxOneClickLead = 201,
    PropertyModalOneClickLead = 202,
    PropertyModalLeadModal = 203,
    PropertyModalOneClickLeadMobileModal = 204,
    PropertyModalLeadModalMobile = 205,
    AfterRecommendationLikeQuestionOneClickLead = 206,
    AfterFavouriteLikeQuestionOneClickLead = 207,
    AfterRecommendationLikeQuestionModal = 208,
    AfterFavouriteLikeQuestionModal = 209,
    PropertyPartnerApiAltar = 210,
    OfferPartnerApiAltar = 211,
    RecommendedPropertiesCarouselAskOffer = 213,
    InvestmentTileAskOffer = 214,
    InvestmentTileLeadModal = 215,
    InvestmentDetailAskOffer = 216,
    InvestmentDetailLeadModal = 217
    // ATTENTION: remember to inform backend to add new value to database validation
}
